import { parsePhoneNumber } from 'libphonenumber-js'

export const formatPrice = price => {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    minimumFractionDigits: 0,
  }).format(price)
}

export const formatDate = date => {
  return new Intl.DateTimeFormat('ru-RU', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(new Date(date))
}

export const truncateText = (text, maxLength = 100) => {
  if (text.length <= maxLength) return text
  return text.slice(0, maxLength) + '...'
}

export const formatPhone = (phone) => {
  if (!phone) {
    return ''
  }

  const raw = String(phone).trim()

  try {
    const parsed = parsePhoneNumber(raw, 'RU')
    if (!parsed) {
      return raw
    }

    const national = parsed.nationalNumber
    if (national.length === 10) {
      return `+7 (${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6, 8)}-${national.slice(8, 10)}`
    }

    return parsed.formatInternational()
  } catch {
    return raw
  }
}
